import React from "react";
import { FormGroup, Label, Input, Button } from "reactstrap";
import { FaPlus, FaMinus } from "react-icons/fa";

const FieldConditionEditor = ({
  index,
  meta,
  allFields,
  onConditionChange,
}) => {
  const conditions = Array.isArray(meta.visibility_condition)
    ? meta.visibility_condition
    : meta.visibility_condition
    ? [meta.visibility_condition]
    : [];

  const handleFieldChange = (i, field) => {
    const updated = [...conditions];
    updated[i] = { ...updated[i], field, value: "" }; // reset value
    onConditionChange(index, updated);
  };

  const handleValueChange = (i, value) => {
    const updated = [...conditions];
    updated[i] = { ...updated[i], value };
    onConditionChange(index, updated);
  };

  const addCondition = () => {
    const updated = [...conditions, { field: "", value: "" }];
    onConditionChange(index, updated);
  };

  const removeCondition = (i) => {
    const updated = conditions.filter((_, idx) => idx !== i);
    onConditionChange(index, updated);
  };

  return (
    <div className="mt-4 p-3 border rounded bg-light">
      <h6 className="fw-bold mb-3 d-flex justify-content-between">
        Visibility Conditions
        <Button size="sm" color="primary" onClick={addCondition}>
          <FaPlus className="me-1" />
          Add Condition
        </Button>
      </h6>

      {conditions.map((condition, i) => {
        const selectedField = allFields.find((f) =>
          Object.values(f.the_meta || {}).some(
            (m) => m.data_name === condition.field
          )
        );

        const selectedMeta = selectedField
          ? Object.values(selectedField.the_meta).find(
              (m) => m.data_name === condition.field
            )
          : null;

        const options = selectedMeta?.options || [];

        return (
          <div
            key={i}
            className="d-flex align-items-center gap-2 mb-2 border rounded p-2 bg-white"
          >
            <select
              className="form-select"
              value={condition.field}
              onChange={(e) => handleFieldChange(i, e.target.value)}
            >
              <option value="">-- Select Field --</option>
              {allFields.map((addon) => {
                const [_, metaValue] =
                  Object.entries(addon.the_meta || {})[0] || [];
                return (
                  metaValue?.data_name && (
                    <option
                      key={addon.productmeta_id}
                      value={metaValue.data_name}
                    >
                      {metaValue.title}
                    </option>
                  )
                );
              })}
            </select>

            <select
              className="form-select"
              value={condition.value}
              onChange={(e) => handleValueChange(i, e.target.value)}
              disabled={!options.length}
            >
              <option value="">-- Select Option --</option>
              {options.map((opt) => (
                <option key={opt.id || opt.option} value={opt.id || opt.option}>
                  {opt.option}
                </option>
              ))}
            </select>

            <Button color="danger" size="sm" onClick={() => removeCondition(i)}>
              <FaMinus />
            </Button>
          </div>
        );
      })}
    </div>
  );
};

export default FieldConditionEditor;
